import React, { useEffect, useState } from 'react';
import '../OnudaanValue/OnudaanValue.css'
const OnudaanValue = () => {
//     const[team,setTeam]=useState([])
// const[deleted,setdeletd]=useState(false)
// useEffect(()=>{
//     console.log(deleted)
//     fetch(' http://localhost:1000/GetInfoDonation')
//     .then(res=>res.json())
//     .then(data=>setTeam(data))
// },[deleted])
    return (

<div class="d-flex align-items-center justify-content-center">
<img className="img-fluid w-75 mt-5" src="https://www.juma.org/wp-content/uploads/2015/06/Under-Construction.jpg" alt="Loading.....Please Wait" />
</div>
    );
};

export default OnudaanValue;